import styled from "@emotion/styled";
import FdButton from "../../components/UIComponents/Button/FdButton";
import { theme } from "../../theme";
export const exhibitorEdit = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  contentWrapper: {
    height: "calc(100vh - 105px)",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  topActions: {
    display: "flex",
    alignItems: "center",
    paddingBottom: "20px",
    justifyContent: "space-between",
  },
  infoTitle: {
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    maxWidth: "calc(100% - 570px)",
  },
  formTitle: {
    backgroundColor: "#fff",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  userImage: {
    width: "5vw",
    height: "5vw",
    maxWidth: "100px",
    maxHeight: "100px",
    position: "relative",
    marginRight: "10px",
    "& .MuiAvatar-root":{
      height:"inherit",
      width:"inherit"
    }
  },
  formContent: {
    position: "relative",
    width: "100%",
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "auto",
    "& .MuiFormControl-root": {
      my: 0,
    },
    "& .MuiFormHelperText-root ": {
      mx: 0,
    },
    "& form": {
      width: "100%",
      textAlign: "left",
      height: "100%",
      display: "contents",
    },
  },
  genericFields: {
    width: "50%",
    height: "100%",
    backgroundColor: theme.palette.grey[600],
    overflow: "auto",
    borderRadius: "5px",
  },
  customFields: {
    width: "40%",
    height: "100%",
    backgroundColor: theme.palette.grey[600],
    overflow: "auto",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
  },
  dateField: {
    marginBottom: "15px",
  },
  timeField: {
    marginBottom: "15px",
  },
  formFields: {
    padding: "10px 20px",
    textAlign: "left",
    "& .Mui-disabled": {
      cursor: "default",
      "&.MuiInputBase-root":{
        backgroundColor:"#ededed",
        boxShadow:"none",
      }
    },
  },
  inputIcon: {
    fontSize: "18px",
    color: theme.palette.grey["800"],
  },
  addInfoFieldButton: {
    // position: "sticky",
    // bottom: 0,
    // left: 0,
    // right: 0,
    // height: "60px",
    // backgroundColor: theme.palette.primary.main,
    zIndex: 11,
    // color: "#fff",
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
    justifyContent: "center",
    cursor: "pointer",
    // marginTop: "auto",
    // minHeight: "60px",
  },
  addIcon: {
    color: "#fff",
    marginRight: "5px",
    fontSize: "18px",
  },
  checkboxesGroup: {
    transformOrigin: "top left",
    transform: "translate(0, 3.5px) scale(0.75)",
  },
  checkboxesGroupInput: {
    "& > span": {
      paddingBottom: "2px",
      paddingTop: "2px",
    },
  },
  attendeeAvatar: {
    width: "100%",
    height: "100%",
  },
};
export const customStyle = {
  "& .MuiInputBase-root.MuiFilledInput-root": {
    border: "1px solid #E7E7E7",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
    borderRadius: "6px !important",
    padding: "12px 10px",
    background: "#fff",
    "&:before,&:after": {
      display: "none",
    },
    "&:hover": {
      background: "#fff",
    },
    "& input": {
      border: 0,
      boxShadow: "none",
      padding: "0 !important",
    },
  },
  "&.noPastErrorStyle .Mui-error": {
    color: theme.palette.text.primary,
  },
  "&.noPastErrorStyle .Mui-error.MuiFormHelperText-root ": {
    color: theme.palette.error.main,
  },

  "& .MuiButtonBase-root ": {
    "& svg": {
      height: "18px",
      width: "18px",
      color: "#A8A8A8",
    },
  },
} as const;


// style for v2
const commonBtnStyle = {
  textTransform: "uppercase",
  color: theme.palette.text.primary,
  borderColor: "rgba(0, 0, 0, 0.23)",
  padding: "5px 15px",
  "&:hover": {
    borderColor: theme.palette.text.primary,
  },
}
export const style2 = {
  timelineBtn:{
    ...commonBtnStyle,
    mt:2,
  },
  inValidateBtn:{
    ...commonBtnStyle,
  },
  barcodeStyle:{    
    p: 1,
    bgcolor: "white",
    display: "inline-flex",
    borderRadius: 1,
    mt: 2,
  },
  newInfofieldBtnStyleIcon:{
    color: "#fff",
    marginRight: "5px",
    fontSize: "18px",
  },
} as const;

export const StyledFdButton = styled(FdButton)((theme) => ({
  color:  "#7BB225"
}));

// Set default props for the styled component
StyledFdButton.defaultProps = {
  variant: 'text',
  color: 'primary',
  size: 'small',
};